import { render, staticRenderFns } from "./activity-list-orm.vue?vue&type=template&id=4728d96a&scoped=true"
import script from "./activity-list-orm.vue?vue&type=script&lang=js"
export * from "./activity-list-orm.vue?vue&type=script&lang=js"
import style0 from "./activity-list-orm.vue?vue&type=style&index=0&id=4728d96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4728d96a",
  null
  
)

export default component.exports